import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/yearReport_popup.css";
import { downloadExcel } from "react-export-table-to-excel";
import { secretKey } from "../.././data";
import Loading from "../helpers/loading_component.js";

const MySwal = withReactContent(Swal2);

const YearReportPopUp = (props) => {
  const [tasks, setTasks] = useState([]);
  const [hearings, setHearings] = useState([]);
  const [loading, setLoading] = useState(true);

  const getDataT1 = () => {
    setLoading(true);
    fetchHearingsTeam1();
    fetchTasksTeam1();
  };

  const fetchHearingsTeam1 = async () => {
    var body = {
      month: new Date(props.date).getMonth() + 1,
      year: new Date(props.date).getFullYear(),
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getHearingsYear", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data = getAllowedClients(data);
        setHearings(data);
      })
      .catch((error) => {});
  };

  const fetchHearingsTeam2 = async () => {
    var body = {
      month: new Date(props.date).getMonth() + 1,
      year: new Date(props.date).getFullYear(),
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getHearingsYear", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data = getAllowedClients(data);
        setHearings(data);
      })
      .catch((error) => {});
  };

  const fetchTasksTeam1 = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getTasksYear", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data = getAllowedClients(data);
        setTasks(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const fetchTasksTeam2 = async () => {
    var body = {
      month: new Date(props.date).getMonth() + 1,
      year: new Date(props.date).getFullYear(),
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getTasksYear", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data = getAllowedClients(data);
        setTasks(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getAllowedClients = (data) => {
    if (props.user.allowedClients === "all") {
      return data;
    } else {
      var allowed = props.user.allowedClients
        .toString()
        .replaceAll(" ", "")
        .split(",");
      var arr = [];
      allowed.map((el) => {
        arr = arr.concat(data.filter((el2) => +el2.clientId === +el));
      });
      return arr;
    }
  };

  const getDataT2 = () => {
    fetchHearingsTeam2();
    fetchTasksTeam2();
  };

  useEffect(() => {
    if (props.team === 1) {
      getDataT1();
    } else {
      getDataT2();
    }
  }, []);

  const getMonthName = () => {
    return props.monthData.filter((el) => +el.id === +props.monthId)[0].name;
  };

  const getUsersForTeam = (e) => {
    var usersForTeam = [];

    props.users.map((el) => {
      if (el.team.split(",").filter((el2) => +el2 === props.team).length > 0) {
        usersForTeam.push(el);
      }
    });

    return usersForTeam;
  };

  const getHearingsOnlineForUser = (name) => {
    return hearings.filter(
      (el) =>
        el.lawyer === name &&
        new Date(el.date).getMonth() + 1 === +props.monthId &&
        new Date(el.date).getFullYear() === +props.year &&
        el.form === "online"
    ).length;
  };

  const getHearingsHouseForUser = (name) => {
    return hearings.filter(
      (el) =>
        el.lawyer === name &&
        new Date(el.date).getMonth() + 1 === +props.monthId &&
        new Date(el.date).getFullYear() === +props.year &&
        el.form === "stacjonarna"
    ).length;
  };

  const getHearingsHouseForUserPersonal = (name) => {
    return hearings.filter(
      (el) =>
        el.lawyer === name &&
        el.lawyer_form === "Osobiście" &&
        new Date(el.date).getMonth() + 1 === +props.monthId &&
        new Date(el.date).getFullYear() === +props.year &&
        el.form === "stacjonarna"
    ).length;
  };

  const getHearingsHouseForUserSubstitute = (name) => {
    return hearings.filter(
      (el) =>
        el.lawyer === name &&
        el.lawyer_form === "Substytut" &&
        new Date(el.date).getMonth() + 1 === +props.monthId &&
        new Date(el.date).getFullYear() === +props.year &&
        el.form === "stacjonarna"
    ).length;
  };

  const getHearingsHouseForUserGuardian = (name) => {
    return hearings.filter(
      (el) =>
        el.lawyer === name &&
        el.lawyer_form === "Opiekun" &&
        new Date(el.date).getMonth() + 1 === +props.monthId &&
        new Date(el.date).getFullYear() === +props.year &&
        el.form === "stacjonarna"
    ).length;
  };

  const getTasksForUser = (name) => {
    return tasks.filter(
      (el) =>
        el.responsible === name &&
        new Date(el.final_date).getMonth() + 1 === +props.monthId &&
        new Date(el.final_date).getFullYear() === +props.year
    ).length;
  };

  const getHearingsOnlineBlank = (name) => {
    return hearings.filter(
      (el) =>
        el.lawyer === "" &&
        new Date(el.date).getMonth() + 1 === +props.monthId &&
        new Date(el.date).getFullYear() === +props.year &&
        el.form === "online"
    ).length;
  };

  const getHearingsHouseBlank = (name) => {
    var hearingMain =
      props.team === 1 ? props.hearingsData : props.hearingsTeam2Data;
    var hearingSheetMain =
      props.team === 1 ? props.hearingsSheetData : props.hearingsTeam2SheetData;
    var taskMain = props.team === 1 ? props.tasksData : props.tasksTeam2Data;
    var tasksSheetMain =
      props.team === 1 ? props.tasksSheetData : props.tasksTeam2SheetData;
    var archDateMain = props.team === 1 ? props.archDate : props.archDateTeam2;
    var archTasksMain =
      props.team === 1 ? props.archTasks : props.archTasksTeam2;

    return hearings.filter(
      (el) =>
        el.lawyer === "" &&
        new Date(el.date).getMonth() + 1 === +props.monthId &&
        new Date(el.date).getFullYear() === +props.year &&
        el.form === "stacjonarna"
    ).length;
  };

  const getTasksBlank = (name) => {
    var hearingMain =
      props.team === 1 ? props.hearingsData : props.hearingsTeam2Data;
    var hearingSheetMain =
      props.team === 1 ? props.hearingsSheetData : props.hearingsTeam2SheetData;
    var taskMain = props.team === 1 ? props.tasksData : props.tasksTeam2Data;
    var tasksSheetMain =
      props.team === 1 ? props.tasksSheetData : props.tasksTeam2SheetData;
    var archDateMain = props.team === 1 ? props.archDate : props.archDateTeam2;
    var archTasksMain =
      props.team === 1 ? props.archTasks : props.archTasksTeam2;

    return tasks.filter(
      (el) =>
        el.responsible === "" &&
        new Date(el.final_date).getMonth() + 1 === +props.monthId &&
        new Date(el.final_date).getFullYear() === +props.year
    ).length;
  };

  const exportHearingExcel = (e) => {
    var hearingMain =
      props.team === 1 ? props.hearingsData : props.hearingsTeam2Data;
    var hearingSheetMain =
      props.team === 1 ? props.hearingsSheetData : props.hearingsTeam2SheetData;
    var taskMain = props.team === 1 ? props.tasksData : props.tasksTeam2Data;
    var tasksSheetMain =
      props.team === 1 ? props.tasksSheetData : props.tasksTeam2SheetData;
    var archDateMain = props.team === 1 ? props.archDate : props.archDateTeam2;
    var archTasksMain =
      props.team === 1 ? props.archTasks : props.archTasksTeam2;

    var header = [
      "ID",
      "Imię i nazwisko",
      "Data rozprawy",
      "Godzina rozprawy",
      "Sąd",
      "Bank",
      "Sygnatura",
      "WPS",
      "Rodzaj rozprawy",
      "Link do rozprawy",
      "Temat rozprawy",
      "Prawnik",
      "Forma reprezentacji",
      "Imię i nazwisko substytuta",
      "Imię i nazwisko opiekuna",
      "Wynik rozprawy",
      "Rodzaj wyniku rozprawy",
      "Notatka do rozprawy",
      "Notatka",
      "Data dodania",
      "Uzytkownik",
      "Zaakceptowano",
      "Status",
    ];
    downloadExcel({
      fileName: "hearings_report_" + getMonthName(),
      sheet: "data",
      tablePayload: {
        header,
        // accept two different data structures
        body: hearings.filter(
          (el) =>
            new Date(el.date).getMonth() + 1 === +props.monthId &&
            new Date(el.date).getFullYear() === +props.year
        ),
      },
    });
  };

  const exportTasksExcel = (e) => {
    var hearingMain =
      props.team === 1 ? props.hearingsData : props.hearingsTeam2Data;
    var hearingSheetMain =
      props.team === 1 ? props.hearingsSheetData : props.hearingsTeam2SheetData;
    var taskMain = props.team === 1 ? props.tasksData : props.tasksTeam2Data;
    var tasksSheetMain =
      props.team === 1 ? props.tasksSheetData : props.tasksTeam2SheetData;
    var archDateMain = props.team === 1 ? props.archDate : props.archDateTeam2;
    var archTasksMain =
      props.team === 1 ? props.archTasks : props.archTasksTeam2;

    var header = [
      "ID",
      "Data rozpoczęcia",
      "Imię i nazwisko",
      "Bank",
      "Sygnatura",
      "Zadanie",
      "Termin wykonania",
      "Osoba odpowiedzialna",
      "Data dodania",
      "Uzytkownik",
      "Status",
    ];
    downloadExcel({
      fileName: "tasks_report_" + getMonthName(),
      sheet: "data",
      tablePayload: {
        header,
        // accept two different data structures
        body: tasks.filter(
          (el) =>
            new Date(el.final_date).getMonth() + 1 === +props.monthId &&
            new Date(el.final_date).getFullYear() === +props.year
        ),
      },
    });
  };

  const exportHearingExcelUser = (e) => {
    var hearingMain =
      props.team === 1 ? props.hearingsData : props.hearingsTeam2Data;
    var hearingSheetMain =
      props.team === 1 ? props.hearingsSheetData : props.hearingsTeam2SheetData;
    var taskMain = props.team === 1 ? props.tasksData : props.tasksTeam2Data;
    var tasksSheetMain =
      props.team === 1 ? props.tasksSheetData : props.tasksTeam2SheetData;
    var archDateMain = props.team === 1 ? props.archDate : props.archDateTeam2;
    var archTasksMain =
      props.team === 1 ? props.archTasks : props.archTasksTeam2;

    var header = [
      "ID",
      "Imię i nazwisko",
      "Data rozprawy",
      "Godzina rozprawy",
      "Sąd",
      "Bank",
      "Sygnatura",
      "WPS",
      "Rodzaj rozprawy",
      "Link do rozprawy",
      "Temat rozprawy",
      "Prawnik",
      "Forma reprezentacji",
      "Imię i nazwisko substytuta",
      "Imię i nazwisko opiekuna",
      "Wynik rozprawy",
      "Rodzaj wyniku rozprawy",
      "Notatka do rozprawy",
      "Notatka",
      "Data dodania",
      "Uzytkownik",
      "Zaakceptowano",
      "Status",
    ];
    downloadExcel({
      fileName: "hearings_report_" + getMonthName() + "_" + e.target.value,
      sheet: "data",
      tablePayload: {
        header,
        // accept two different data structures
        body: hearings.filter(
          (el) =>
            (el.lawyer === e.target.value &&
              new Date(el.date).getMonth() + 1) === +props.monthId &&
            new Date(el.date).getFullYear() === +props.year
        ),
      },
    });
  };

  const exportTasksExcelUser = (e) => {
    var hearingMain =
      props.team === 1 ? props.hearingsData : props.hearingsTeam2Data;
    var hearingSheetMain =
      props.team === 1 ? props.hearingsSheetData : props.hearingsTeam2SheetData;
    var taskMain = props.team === 1 ? props.tasksData : props.tasksTeam2Data;
    var tasksSheetMain =
      props.team === 1 ? props.tasksSheetData : props.tasksTeam2SheetData;
    var archDateMain = props.team === 1 ? props.archDate : props.archDateTeam2;
    var archTasksMain =
      props.team === 1 ? props.archTasks : props.archTasksTeam2;

    var header = [
      "ID",
      "Data rozpoczęcia",
      "Imię i nazwisko",
      "Bank",
      "Sygnatura",
      "Zadanie",
      "Termin wykonania",
      "Osoba odpowiedzialna",
      "Data dodania",
      "Uzytkownik",
      "Status",
    ];
    downloadExcel({
      fileName: "tasks_report_" + getMonthName() + "_" + e.target.value,
      sheet: "data",
      tablePayload: {
        header,
        // accept two different data structures
        body: tasks.filter(
          (el) =>
            (el.responsible === e.target.value &&
              new Date(el.final_date).getMonth() + 1) === +props.monthId &&
            new Date(el.final_date).getFullYear() === +props.year
        ),
      },
    });
  };

  return (
    <>
      <div className="mainContainerYearReportPopUp">
        {loading ? (
          <Loading />
        ) : (
          <>
            <div className="closeBox">
              <button
                className="closeButtonYearReport"
                onClick={props.closeReport}
              >
                X
              </button>
            </div>
            <div className="reportTitle">{getMonthName()}</div>
            <div className="reportButtons">
              <button
                id="exButton"
                className="acceptButton"
                value={props.user.name}
                onClick={exportHearingExcel}
              >
                EXPORT ROZPRAW
              </button>
              <button
                id="exButton"
                className="acceptButton"
                value={props.user.name}
                onClick={exportTasksExcel}
              >
                EXPORT ZADAŃ
              </button>
            </div>
            <div className="reportContent">
              {getUsersForTeam().map((el) => (
                <>
                  <div className="reportRow">
                    <b>{el.name}</b>
                    <div className="reportSubBox">
                      <div id="reportSubRowContent" className="reportSubRow">
                        <p>
                          Ilość rozpraw stacjonarnych:{" "}
                          {getHearingsHouseForUser(el.name)}
                        </p>
                        <p id="subP">
                          Osobiście: {getHearingsHouseForUserPersonal(el.name)}
                        </p>
                        <p id="subP">
                          Substytut:{" "}
                          {getHearingsHouseForUserSubstitute(el.name)}
                        </p>
                        <p id="subP">
                          Opiekun: {getHearingsHouseForUserGuardian(el.name)}
                        </p>
                        <p>
                          Ilość rozpraw online:{" "}
                          {getHearingsOnlineForUser(el.name)}
                        </p>
                        <p>Ilość zadań: {getTasksForUser(el.name)}</p>
                      </div>
                      <div className="reportSubRow">
                        <button
                          id="exButtonSub"
                          className="acceptButton"
                          value={el.name}
                          onClick={exportHearingExcelUser}
                        >
                          EXPORT ROZPRAW
                        </button>
                        <button
                          id="exButtonSub"
                          className="acceptButton"
                          value={el.name}
                          onClick={exportTasksExcelUser}
                        >
                          EXPORT ZADAŃ
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              ))}
              <div className="reportRow">
                <b>{"NIEPRZYPISANE"}</b>
                <div className="reportSubRow">
                  <p>Ilość rozpraw stacjonarnych: {getHearingsHouseBlank()}</p>
                  <p>Ilość rozpraw online: {getHearingsOnlineBlank()}</p>
                  <p>Ilość zadań: {getTasksBlank()}</p>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default YearReportPopUp;
